import { AdminRouteMap, InitialRouteMap } from '_constants';
import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { AdminRoutes } from 'routes';
import {
  ChangePasswordView,
  ForgotPasswordView as ForgotPassword,
  LoginView as Login,
  ResetPasswordView,
} from 'views';

import { LoggedInViewWrapper } from './LoggedInViewWrapper';

export const InitialRoutes = () => (
  <Routes>
    <Route index element={<Navigate to={InitialRouteMap.LOGIN} />} />
    <Route path={InitialRouteMap.FORGOTPASSWORD} element={<ForgotPassword />} />
    <Route path={InitialRouteMap.LOGIN} element={<Login />} />
    <Route path={InitialRouteMap.CHANGEPASSWORD} element={<ChangePasswordView />} />
    <Route path={InitialRouteMap.RESETPASSWORD} element={<ResetPasswordView />} />
    <Route path={InitialRouteMap.ANY} element={<Navigate to={InitialRouteMap.LOGIN} />} />
    <Route path={InitialRouteMap.REST} element={<LoggedInViewWrapper />}>
      <Route path={AdminRouteMap.ANY} element={<AdminRoutes />} />
    </Route>
  </Routes>
);
